export const SECURITY_TITLE = "Backed by enterprise-grade security and scale";

export const SECURITY_DESCRIPTION =
  "Windmill is built from the ground up with security in mind. We use industry-standard " +
  "encryption and secure protocols to protect your data.";

export const SECURITY_COMPLIANCE = "We are SOC 2 compliant.";
